import type { CSSProperties } from "react";

type SliderStyle = CSSProperties & { "--track": string };

export function Slider({
  label,
  value,
  max,
  gradient,
  disabled,
  onChange,
  suffix,
}: {
  label: string;
  value: number;
  max: number;
  gradient: string;
  disabled?: boolean;
  onChange: (next: number) => void;
  suffix?: string;
}) {
  const style: SliderStyle = { "--track": gradient };
  return (
    <label className="slider">
      <span>
        {label}
        <b aria-live="polite">
          {value}
          {suffix ?? ""}
        </b>
      </span>
      <input
        className="slider-input"
        style={style}
        disabled={disabled}
        type="range"
        min={0}
        max={max}
        step={1}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        aria-label={label}
      />
    </label>
  );
}
